import {Grid, Stack, SxProps, Theme, Typography, useMediaQuery} from "@mui/material";
import {useContext} from "react";
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";
import {Product} from "../contexts/types";
import {Box} from "@mui/system";
import {useTheme} from "@mui/styles";

type SelectedProductDisplayProps = {
    product: Product
    sx: SxProps<Theme>,
    endAdornment?: React.ReactNode
}

const SelectedProductDisplay: React.FC<SelectedProductDisplayProps> = ({product, sx, endAdornment}) => {
    const {t} = useContext(OrgCustomizationContext)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Stack
            direction={isMobile ? 'column' : 'row'}
            spacing={2}
            justifyContent='space-between'
            alignItems='baseline'
            sx={{
                width: '100%',
                border: '1px solid #9D9D9D',
                backgroundColor: '#eee',
                padding: '10px 30px',
                color: '#656565',
                ...sx
            }}>
            <Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
                        {t('material_number')}
                    </Typography>
                    {endAdornment}
                </Box>
                <Typography variant='body1'>
                    {product?.productId}
                </Typography>
            </Box>
            <Box>
                <Typography variant='subtitle1' sx={{fontWeight: 'bold'}}>
                    {t('description')}
                </Typography>
                <Typography variant='body1'>
                    {product?.shortDescription}
                </Typography>
            </Box>
            
        </Stack>
    )
}

export default SelectedProductDisplay
